export default __webpack_public_path__ + "689ed50133145feb492fba20ec93d2ea.webp";